import { render } from "./VISCard.vue?vue&type=template&id=7751ce58&scoped=true"
import script from "./VISCard.vue?vue&type=script&lang=js"
export * from "./VISCard.vue?vue&type=script&lang=js"

import "./VISCard.vue?vue&type=style&index=0&id=7751ce58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7751ce58"]])

export default __exports__